import ChsAddress from 'domain/types/ChsAddress';

export interface Address extends Record<string, unknown> {
  houseNumber: string;
  halfNumber: string;
  streetDir: string;
  streetName: string;
  streetType: string;
  unitNum: string;
  unitType: string;
  zip: string;
  city: string;
  state: string;
}

export function formatAddressLine1(address: Address | ChsAddress) {
  const { houseNumber, halfNumber, streetDir, streetName, streetType } =
    address;

  const part1 = [
    houseNumber,
    // 1/2 address field removed from screen
    halfNumber === 'Y' ? '1/2' : null,
    streetDir,
    streetName,
    streetType,
  ];

  if (part1.every((v) => !Boolean(v) || v === 'Unit')) {
    return formatAddress(address);
  }

  return part1.join(' ');
}

export default function formatAddress(address: Address | ChsAddress) {
  const {
    houseNumber,
    halfNumber,
    streetDir,
    streetName,
    streetType,
    unitType,
    city,
    state,
  } = address;

  const part1 = [
    houseNumber,
    // 1/2 address field removed from screen
    halfNumber === 'Y' ? '1/2' : null,
    streetDir,
    streetName,
    streetType,
  ];
  const part2 = [
    unitType || 'Unit',
    (address as Address)['unitNum'] || address['unitNumber'],
  ];
  const part3 = [city];
  const part4 = [state, (address as Address)['zip'] || address['zipCode']];

  const whole = [...part1, ...part2, ...part3, ...part4];
  if (whole.every((v) => !Boolean(v) || v === 'Unit')) {
    return '(empty)';
  }

  return `${part1.filter((e) => e).join(' ')}, ${part2.join(' ')}, ${part3.join(
    ' '
  )}, ${part4.join(' ')}`;
}
